import React from 'react';

const BenefitsBanner = () => {
    return (
        <>
            <div className="cpp-page__benefits-banner">
                <div className="section-heading">Get exclusive benefits</div>
                <div className="section-content">
                    <p>
                        For the 2027/28 Connectivity Partner Program, both Elite
                        and Preferred partners will be eligible for the
                        following potential benefits, unless otherwise noted.
                        <sup>1</sup>
                    </p>
                </div>

                <div className="benefits-banner__options">
                    <div className="benefits-banner__option">
                        <h3>Business advantages</h3>
                        <ul>
                            <li>
                                Dedicated account and technical support
                            </li>
                            <li>Regular business performance reviews</li>
                            <li>Access to financial incentives</li>
                            <li>Quarterly performance scorecard email</li>
                        </ul>
                    </div>
                    <div className="benefits-banner__option">
                        <h3>Product collaboration &amp; first access</h3>
                        <ul>
                            <li>
                                Early access to APIs and capabilities
                                <sup>2</sup>
                            </li>
                            <li>Collaboration in product reviews</li>
                            <li>Access to industry trends research</li>
                        </ul>
                    </div>
                    <div className="benefits-banner__option">
                        <h3>Co-marketing and promotion</h3>
                        <ul>
                            <li>
                                Featured in 2028 Elite & Preferred partner campaign
                            </li>
                            <li>
                                Optional discounts & promotions on Provider Guide to help you capture new clients
                            </li>
                            <li>Elite-only lead capture capability</li>
                            <li>
                                Featured placement on top of the search page
                            </li>
                            <li>Elite-only enhanced description on Provider Guide </li>
                            <li>
                                Eligibility for sponsorship of our events
                            </li>
                            <li>
                                Speaking opportunities at regional and online events
                            </li>
                            <li>Exclusive Elite-only event invitations with leadership access</li>
                            <li>Self-serve status promotion toolkits </li>
                            <li>Media spotlight for first API pilot adopters</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BenefitsBanner;
